<template>
  <v-data-table
    class="nx-entity-version-selector"
    :items="entityVersions"
    :headers="headers"
    :loading="loading"
    :rows-per-page-items="[5 ,10 ,25 , { 'text': '$vuetify.dataIterator.rowsPerPageAll', 'value': 999}]"
    :pagination.sync="pagination"
    :total-items="numResults">
    <template #items="{ item }">
      <tr @click="$emit('input', item)" class="cursor-pointer">
        <td>
          <v-icon
            v-text="value === item.id ? 'radio_button_checked' : 'radio_button_unchecked'"
            :color="value === item.id ? 'accent' : 'default'"
          ></v-icon>
        </td>
        <td>
          <span>
            {{ item.relativeVersionId }}
          </span>
        </td>
        <td>
          <nx-staff-chip v-if="item.creationStaff" :staff="item.creationStaff"></nx-staff-chip>
          <span v-else>-</span>
        </td>
        <td>
          <nx-staff-chip v-if="item.schedulePublishStaff"
                         :staff="item.schedulePublishStaff"
                         :label="$t('message.metadata.scheduledStaffId')"></nx-staff-chip>
          <nx-staff-chip v-else-if="item.publicationStaff"
                         :staff="item.publicationStaff"
                         :label="$t('message.metadata.publicationStaffId')"></nx-staff-chip>
          <span v-else>-</span>
        </td>
        <td v-if="item.creationDate">{{ item.creationDate | formatDate }}</td>
        <td v-else>-</td>
        <td v-if="item.schedulePublish" class="scheduled">{{ item.schedulePublish | formatDate }}</td>
        <td v-else-if="item.startPublicationDate">{{ item.startPublicationDate | formatDate }}</td>
        <td v-else>-</td>
        <td v-if="item.endPublicationDate">{{ item.endPublicationDate | formatDate }}</td>
        <td v-else>-</td>
        <td v-text="statusText(item.status)"></td>
      </tr>
    </template>
    <template #no-results>
      <td></td>
    </template>
  </v-data-table>
</template>

<script>
import apiFactory from '@/modules/entity/api';
import NxStaffChip from '@/components/chips/Staff';

export default {
  name: 'nx-entity-version-selector',
  components: {
    NxStaffChip,
  },
  props: {
    entity: {
      type: String,
      required: true,
    },
    entityId: {
      type: Number,
      required: true,
    },
    value: {
      type: Number,
    },
  },
  data() {
    return {
      numResults: -1,
      loading: false,
      pagination: {
        page: 1,
        rowsPerPage: 10,
      },
      headers: [
        {
          value: 'selected',
          sortable: false,
          width: '20px',
        },
        {
          text: 'Id',
          value: 'id',
          sortable: false,
        },
        {
          text: 'Creado por',
          value: 'staff',
          sortable: false,
        },
        {
          text: 'Publicado por',
          value: 'staff',
          sortable: false,
        },
        {
          text: 'Fecha de creación',
          value: 'creationDate',
          sortable: false,
        },
        {
          text: 'Inicio de publicación',
          value: 'startPublicationDate',
          sortable: false,
        },
        {
          text: 'Fin de publicación',
          value: 'endPublicationDate',
          sortable: false,
        },
        {
          text: 'Estado',
          value: 'state',
          sortable: false,
        },
      ],
      entityVersions: [],
    };
  },
  computed: {
    limit() {
      return this.pagination.rowsPerPage;
    },
    page() {
      return this.pagination.page;
    },
  },
  methods: {
    statusText(status) {
      const statusToText = {
        draft: 'Borrador',
        published: 'Publicado',
        scheduled: 'Programada',
        'was-published': 'Publicado con anterioridad',
      };
      return statusToText[status];
    },
    async loadEntityVersions(entityId, page, limit) {
      this.loading = true;
      const api = apiFactory(this.entity);
      const {
        numResults = -1,
        versions = [],
      } = await api.versions(entityId, page, limit);
      this.entityVersions = versions;
      this.numResults = numResults;
      this.loading = false;
    },
  },
  watch: {
    entityId: {
      async handler(value) {
        this.pagination.page = 1;
        await this.loadEntityVersions(value, this.page, this.limit);
      },
      immediate: true,
    },
    async page(value) {
      await this.loadEntityVersions(this.entityId, value, this.limit);
    },
    async limit(value) {
      await this.loadEntityVersions(this.entityId, this.page, value);
    },
  },
};
</script>

<style lang="stylus" scoped>
.scheduled {
  color: #FFA01C
  font-weight: 500
}
</style>
